export enum EOfferType
{
	FinanceText = 1,
	VehicleText = 3,
	VehiclePrice = 4
}
export enum EOfferTypePillText
{
	FinanceText = 'Finance Offer',
	VehicleText = 'Driveaway Offer',
	VehiclePrice = 'Driveaway Offer'	
}
export enum EFlow 
{
	campaign = 'campaign',
	businessCampaign = 'business-campaign',
	indicative = 'indicative',
	business = 'business',
	getTpr = 'get-tpr',
	adjustTpr = 'adjust-tpr',
	cash = 'cash'
}
export enum EFinaceToggleTypes 
{
	cash = 'cash',
	finance = 'finance'
}